import { queryCheckPermission } from "@/graphql/schemas/user/queries/queryCheckPermission"

import { mutationSignInUser } from "./mutations/mutationSignInUser"
import { queryAdmUser } from "./queries/queryAdmUser"
import { queryCustomerBases } from "./queries/queryCustomerBases"
import { queryUserAssginedBranch } from "./queries/queryUserAssignedBranch"
import { typeUser } from "./user"

const userSchema = {
  types: [typeUser],
  resolvers: {
    Query: {
      ...queryAdmUser,
      ...queryCustomerBases,
      ...queryCheckPermission,
      ...queryUserAssginedBranch,
    },
    Mutation: {
      ...mutationSignInUser,
    },
  },
}

export default userSchema
